import Spinner from "@atlaskit/spinner";

export const LoadingSpinner = (
    <div
        role="alert"
        aria-label="Loading"
        data-testid="global-nav-user-profile-container-spinner"
    >
        <Spinner />
    </div>
);
